import styled from "styled-components"
import UserMenu from "./UserMenu"
import { useState, useEffect } from "react"
import axios from "axios"
import { useAuthStore } from "../store/store"
import moment from "moment"
import { NavLink } from "react-router-dom"
import FormatPrice from '../Helpers/FormatPrice'
import PageHeader from "../components/PageCloseButton";

const Orders = () => {
  const { auth } = useAuthStore();
  const [orders, setOrders] = useState([])
  const [sortOrder, setSortOrder] = useState("asc"); // asc or desc

  const getOrders = async () => {
    try {
      const { data } = await axios.get("/api/orders", {
        headers: {
          Authorization: `Bearer ${auth.token}`
        }
      });
      // setOrders(data);
      if (data.success) {
  setOrders(data.orders);
}
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (auth?.token) getOrders();
  }, [auth?.token]);

  // Sort orders by date
  const sortedOrders = [...orders].sort((a, b) => {
    const dateA = moment(a.createdAt).valueOf();
    const dateB = moment(b.createdAt).valueOf();
    return sortOrder === "asc" ? dateA - dateB : dateB - dateA;
  });

  return (
    <Wrapper>
      <div className="grid grid-two-column">
        <UserMenu />
        <div className="order-container">         
            <PageHeader title="Your Orders"/>
          <div className="table-container">          
            <table>
              <thead>
                <tr>
                  <th
                    onClick={() =>
                      setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"))
                    }
                    style={{ cursor: "pointer" }}
                  >
                    Date {sortOrder === "asc" ? "▲" : "▼"}
                  </th>
                  <th>Order No</th>
                  <th>Shipping Address</th>
                  <th>Email</th>
                  <th>Amount</th>
                  <th>Payment</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(sortedOrders) && sortedOrders.length > 0 ? (
                  sortedOrders.map((order) => (
                    <tr key={order._id}>
                      <td>{moment(order?.createdAt).format("DD/MM/YYYY")}</td>
                      <td>
                        <NavLink to={`/orderprint/${order._id}`}>
                          {order.orderNumber}
                        </NavLink>
                      </td>
                      <td>
                        {order.address ? (
                          <>
                            {order.address.name}, <br />
                            {order.address.street_add}, <br />
                            {order.address.city}, {order.address.state_province}, <br />
                            {order.address.zipcode}, {order.address.country} <br />
                          </>
                        ) : (
                          "No Address"
                        )}
                      </td>
                      <td>
                        {order.buyer?.email}
                        {order.buyer?.mobile}
                      </td>
                      <td>
                        <FormatPrice
                          price={
                            order.products?.reduce(
                              (acc, item) => acc + item.quantity * item.price,
                              0
                            ) + (order.shippingCharge || 0)
                          }
                        />
                      </td>
                      <td>{order.payment ? `${order.payment}` : "Failed"}</td>
                      <td> 
                        <span className={`status ${order.status}`}>
                          {order.status}
                          </span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7">No orders found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div> 
        </div>
    </div>
    </Wrapper >
  )
}
const Wrapper = styled.div`

.grid-two-column{
    display: grid;
    grid-template-columns: 2fr 8fr; 
    gap: 2rem;
    }

.order-container {  
    padding: 2rem;
    }

.table-container {
    margin-top:2rem;
    margin-bottom:2rem;
    max-height: 400px; /* adjust as needed */
    overflow-y: auto;
    border: 1px solid #ddd;
    box-shadow: 0 4px 12px rgba(0,0,0,0.3);
    }
  

table {
    margin:2rem ;
    width: 97%;
    border-collapse: collapse;
    background: #fff;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0,0,0,0.08);
    }
 
thead {
    background-color:${({ theme }) => theme.colors.font};
    color: #fff;
    }

thead th {
    position: sticky;
    top: 0;
    padding: 12px;
    font-size: 14px;
    text-align: left;
    letter-spacing: 0.5px;
    z-index: 2; /* ensures header stays above rows */
    }

thead th.sortable {
    cursor: pointer;
    }

tbody tr {
    border-bottom: 1px solid #eee;
    transition: 0.2s ease;
    }

tbody tr:hover {
    background-color: #f9f9f9;
   }

td {
    padding: 12px;
    font-size: 14px;
    vertical-align: top;
    }

td div {
    margin-bottom: 4px;
    }

  

  /* Status badge */
.status {
    padding: 4px 8px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 500;
    display: inline-block;
    }

.status.Pending { color: #8e6f14; }
.status.ProformaSend { color: #9333ea; }
.status.Processing { color: #2563eb; }
.status.Shipped { color: #eab308; }
.status.Email { color: #0d9488; }
.status.Delivered { color: #155724; }
.status.Cancelled { color: #dc2626; }
    


@media (max-width: ${({ theme }) => theme.media.mobile}) {

.grid-two-column {
    grid-template-columns: 1fr;
    }  

table, thead, tbody, th, td, tr {
    display: block; 
    }

table {
    width: 90%;
    }

thead {
    display: none;
    }

tr {
     margin-bottom: 1rem;
    border: 1px solid #d7d5d5;
    border-radius: 8px;
    padding: 6px;
    }

td {    
      border: none;
      position: relative;
      padding: 0.5rem 0.5rem 0.5rem 1rem;
     }

tbody tr td::before {
    content: attr(data-label);
    font-weight: bold;
     left: 0.2rem;
    position: absolute;
    } 
}
  
`;

export default Orders